/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetInboxGroupByIdDto } from '../models/custom-result-of-get-inbox-group-by-id-dto';
import { CustomResultOfListOfSimpleListDto } from '../models/custom-result-of-list-of-simple-list-dto';
import { CustomResultOfPaginatedListOfGetInboxGroupsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-inbox-groups-with-pagination-dto';
import { inboxGroupsCreateInboxGroupGet } from '../fn/inbox-groups/inbox-groups-create-inbox-group-get';
import { InboxGroupsCreateInboxGroupGet$Params } from '../fn/inbox-groups/inbox-groups-create-inbox-group-get';
import { inboxGroupsCreateInboxGroupPost } from '../fn/inbox-groups/inbox-groups-create-inbox-group-post';
import { InboxGroupsCreateInboxGroupPost$Params } from '../fn/inbox-groups/inbox-groups-create-inbox-group-post';
import { inboxGroupsDeleteInboxGroup } from '../fn/inbox-groups/inbox-groups-delete-inbox-group';
import { InboxGroupsDeleteInboxGroup$Params } from '../fn/inbox-groups/inbox-groups-delete-inbox-group';
import { inboxGroupsGetInboxGroupList } from '../fn/inbox-groups/inbox-groups-get-inbox-group-list';
import { InboxGroupsGetInboxGroupList$Params } from '../fn/inbox-groups/inbox-groups-get-inbox-group-list';
import { inboxGroupsGetInboxGroupsAuditWithPagination } from '../fn/inbox-groups/inbox-groups-get-inbox-groups-audit-with-pagination';
import { InboxGroupsGetInboxGroupsAuditWithPagination$Params } from '../fn/inbox-groups/inbox-groups-get-inbox-groups-audit-with-pagination';
import { inboxGroupsGetInboxGroupsWithPagination } from '../fn/inbox-groups/inbox-groups-get-inbox-groups-with-pagination';
import { InboxGroupsGetInboxGroupsWithPagination$Params } from '../fn/inbox-groups/inbox-groups-get-inbox-groups-with-pagination';
import { inboxGroupsUpdateInboxGroupGet } from '../fn/inbox-groups/inbox-groups-update-inbox-group-get';
import { InboxGroupsUpdateInboxGroupGet$Params } from '../fn/inbox-groups/inbox-groups-update-inbox-group-get';
import { inboxGroupsUpdateInboxGroupPut } from '../fn/inbox-groups/inbox-groups-update-inbox-group-put';
import { InboxGroupsUpdateInboxGroupPut$Params } from '../fn/inbox-groups/inbox-groups-update-inbox-group-put';

@Injectable({ providedIn: 'root' })
export class InboxGroupsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `inboxGroupsCreateInboxGroupGet()` */
  static readonly InboxGroupsCreateInboxGroupGetPath = '/InboxGroups/CreateInboxGroup';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxGroupsCreateInboxGroupGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  inboxGroupsCreateInboxGroupGet$Response(params?: InboxGroupsCreateInboxGroupGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return inboxGroupsCreateInboxGroupGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxGroupsCreateInboxGroupGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inboxGroupsCreateInboxGroupGet(params?: InboxGroupsCreateInboxGroupGet$Params, context?: HttpContext): Observable<Blob> {
    return this.inboxGroupsCreateInboxGroupGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `inboxGroupsCreateInboxGroupPost()` */
  static readonly InboxGroupsCreateInboxGroupPostPath = '/InboxGroups/CreateInboxGroup';

  /**
   * Create Inbox Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxGroupsCreateInboxGroupPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxGroupsCreateInboxGroupPost$Response(params: InboxGroupsCreateInboxGroupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return inboxGroupsCreateInboxGroupPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Inbox Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxGroupsCreateInboxGroupPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxGroupsCreateInboxGroupPost(params: InboxGroupsCreateInboxGroupPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.inboxGroupsCreateInboxGroupPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `inboxGroupsUpdateInboxGroupPut()` */
  static readonly InboxGroupsUpdateInboxGroupPutPath = '/InboxGroups/UpdateInboxGroup';

  /**
   * Update Inbox Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxGroupsUpdateInboxGroupPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxGroupsUpdateInboxGroupPut$Response(params: InboxGroupsUpdateInboxGroupPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return inboxGroupsUpdateInboxGroupPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Inbox Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxGroupsUpdateInboxGroupPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxGroupsUpdateInboxGroupPut(params: InboxGroupsUpdateInboxGroupPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.inboxGroupsUpdateInboxGroupPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `inboxGroupsUpdateInboxGroupGet()` */
  static readonly InboxGroupsUpdateInboxGroupGetPath = '/InboxGroups/UpdateInboxGroup/{id}';

  /**
   * Get Inbox Group By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxGroupsUpdateInboxGroupGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  inboxGroupsUpdateInboxGroupGet$Response(params: InboxGroupsUpdateInboxGroupGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetInboxGroupByIdDto>> {
    return inboxGroupsUpdateInboxGroupGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Inbox Group By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxGroupsUpdateInboxGroupGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inboxGroupsUpdateInboxGroupGet(params: InboxGroupsUpdateInboxGroupGet$Params, context?: HttpContext): Observable<CustomResultOfGetInboxGroupByIdDto> {
    return this.inboxGroupsUpdateInboxGroupGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetInboxGroupByIdDto>): CustomResultOfGetInboxGroupByIdDto => r.body)
    );
  }

  /** Path part for operation `inboxGroupsDeleteInboxGroup()` */
  static readonly InboxGroupsDeleteInboxGroupPath = '/InboxGroups';

  /**
   * Delete Inbox Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxGroupsDeleteInboxGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  inboxGroupsDeleteInboxGroup$Response(params?: InboxGroupsDeleteInboxGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return inboxGroupsDeleteInboxGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Inbox Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxGroupsDeleteInboxGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inboxGroupsDeleteInboxGroup(params?: InboxGroupsDeleteInboxGroup$Params, context?: HttpContext): Observable<CustomResult> {
    return this.inboxGroupsDeleteInboxGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `inboxGroupsGetInboxGroupsWithPagination()` */
  static readonly InboxGroupsGetInboxGroupsWithPaginationPath = '/InboxGroups/GetInboxGroupsWithPagination';

  /**
   * Get Inbox Groups With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxGroupsGetInboxGroupsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxGroupsGetInboxGroupsWithPagination$Response(params: InboxGroupsGetInboxGroupsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetInboxGroupsWithPaginationDto>> {
    return inboxGroupsGetInboxGroupsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Inbox Groups With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxGroupsGetInboxGroupsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxGroupsGetInboxGroupsWithPagination(params: InboxGroupsGetInboxGroupsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetInboxGroupsWithPaginationDto> {
    return this.inboxGroupsGetInboxGroupsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetInboxGroupsWithPaginationDto>): CustomResultOfPaginatedListOfGetInboxGroupsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `inboxGroupsGetInboxGroupsAuditWithPagination()` */
  static readonly InboxGroupsGetInboxGroupsAuditWithPaginationPath = '/InboxGroups/GetInboxGroupsAuditWithPagination';

  /**
   * Get Inbox Groups Audit With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxGroupsGetInboxGroupsAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxGroupsGetInboxGroupsAuditWithPagination$Response(params: InboxGroupsGetInboxGroupsAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return inboxGroupsGetInboxGroupsAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Inbox Groups Audit With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxGroupsGetInboxGroupsAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxGroupsGetInboxGroupsAuditWithPagination(params: InboxGroupsGetInboxGroupsAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.inboxGroupsGetInboxGroupsAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `inboxGroupsGetInboxGroupList()` */
  static readonly InboxGroupsGetInboxGroupListPath = '/InboxGroups/GetInboxGroupList';

  /**
   * Get Inbox Group List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxGroupsGetInboxGroupList()` instead.
   *
   * This method doesn't expect any request body.
   */
  inboxGroupsGetInboxGroupList$Response(params?: InboxGroupsGetInboxGroupList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfSimpleListDto>> {
    return inboxGroupsGetInboxGroupList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Inbox Group List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxGroupsGetInboxGroupList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inboxGroupsGetInboxGroupList(params?: InboxGroupsGetInboxGroupList$Params, context?: HttpContext): Observable<CustomResultOfListOfSimpleListDto> {
    return this.inboxGroupsGetInboxGroupList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfSimpleListDto>): CustomResultOfListOfSimpleListDto => r.body)
    );
  }

}
